export const EMBEDDED_CHAT_CONFIG = {
  iconSize: {
    logo: 32,
    actionButton: 16,
  },
  actionButtonClassName: 'rounded-lg bg-white hover:bg-slate-50 text-blue-600 p-8',
} as const;
